import React from 'react';
import { Container, Box, Typography, Breadcrumbs, Link, useTheme, alpha } from '@mui/material';
import { Dashboard as DashboardIcon, Search as SearchIcon } from '@mui/icons-material';
import { Link as RouterLink } from 'react-router-dom';
import OpenSearchDashboard from '../../components/OpenSearchMonitoring/OpenSearchDashboard';

const OpenSearchMonitoringPage = () => {
  const theme = useTheme();
  
  return (
    <Container maxWidth="xl" sx={{ pb: 4 }}>
      <Box mb={4}>
        <Box sx={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center', 
          mb: 2,
          flexWrap: { xs: 'wrap', md: 'nowrap' },
          gap: 2
        }}>
          <Box>
            <Breadcrumbs aria-label="breadcrumb">
              <Link component={RouterLink} to="/" color="inherit" sx={{ display: 'flex', alignItems: 'center' }}>
                <DashboardIcon sx={{ mr: 0.5, fontSize: '1rem' }} />
                Dashboard
              </Link>
              <Typography color="text.primary" sx={{ display: 'flex', alignItems: 'center' }}>
                <SearchIcon sx={{ mr: 0.5, fontSize: '1rem' }} />
                OpenSearch Monitoring
              </Typography>
            </Breadcrumbs>
            <Typography 
              variant="h4" 
              component="h1" 
              fontWeight="bold" 
              sx={{ 
                mt: 1,
                background: `linear-gradient(45deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text',
                textFillColor: 'transparent'
              }}
            >
              OpenSearch Monitoring Dashboard
            </Typography>
          </Box>
        </Box>
        
        <OpenSearchDashboard />
      </Box>
    </Container>
  );
};

export default OpenSearchMonitoringPage; 